import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// components
import SearchTablePageLayout from '../../../components/alcohol/layout/searchTablePage/SearchTablePageLayout';
import CommonModal from '../../../components/modal/CommonModal';

// api
import { deletePatientFromAlcohol, getPatientFromAlcohol, getPsctCodeFromAlcohol, postPatientToAlcohol } from '../../../services/apis/alcohol/patient';



const pageInfo = {
	title: '환자 관리',
	search: {
		inputPlaceholder: `의료진 코드, 이름`
	},
	list: {
		title: '환자 리스트',
		selectOptionList: [
			{
				key: "id",
				value: "id",
				name: "번호"
			},
			{
				key: "name",
				value: "name",
				name: "이름"
			},
			{
				key: "age",
				value: "age",
				name: "나이"
			}
		],
		tableHeader: ['번호', '이름', '의료진 코드', '전화번호', '생년월일', '성별', '나이', '환자군', '문제성 음주', '변화 준비', '교육'],
		deleteTableHeader: ['번호', '이름', '성별', '전화번호', '생년월일']
	},
	dataMatchEngToKor: {
		key: {
			psctId: '번호',
			name: '이름',
			psctCode: '의료진 코드',
			phoneNumber: '전화번호',
			birth: '생년월일',
			sex: '성별',
			age: '나이',
			patientGroup: '환자군',
			audit: '문제성 음주',
			rtcq: '변화 준비',
			training: '교육'
		},
		training: {
			10: "시작 전",
			20: "정상",
			30: "종료",
			40: "미달",
			45: "탈락"
		},
		patientGroup: {
			exp: "실험군",
			comp: "대조군",
			tester: "테스트",
			common: "일반"
		}
	},
	dataMatchKorToEng: {
		key: {
			번호: 'psctId',
			이름: 'name',
			'의료진 코드': 'psctCode',
			전화번호: 'phoneNumber',
			생년월일: 'birth',
			성별: 'sex',
			나이: 'age',
			환자군: 'patientGroup',
			'문제성 음주': 'audit',
			'변화 준비': 'rtcq',
			교육: 'training'
		},
		searchOption: {
			patientGroup: {
				실험군: 'exp',
				대조군: 'comp',
				테스트: 'tester',
				일반: 'common'
			},
			training: {
				"시작 전": '10',
				정상: '20',
				종료: '30',
				미달: '40',
				탈락: '45'
			}
		}
	}	
}


function AlcoholPatientManageListPage() {
	const navigate = useNavigate();
	const [tableBody, setTableBody] = useState([]);
	const [selectedPatients, setSelectedPatients] = useState([]);
	const [totalDataCnt, setTotalDataCnt] = useState(0);

	const [selectedPage, setSelectedPage] = useState(1);

	const [totalCheck, setTotalCheck] = useState(false);

	const [inputSearchOption, setInputSearchOption] = useState({
		search: "",
		// High / Low
		patientTypeProblem: "",
		// Ready / No
		patientTypeChange: "",
		// exp / comp / tester / common
		patientGroup: "",
		// total / normal / fallsort
		progress: ""
	})
	const [searchOption, setSearchOption] = useState({
		search: "",
		patientTypeProblem: "",
		patientTypeChange: "",
		patientGroup: "",
		progress: ""
	});

	const [selectedOrderOption, setSelectedOrderOption] = useState("id");

	const goToSelectedPatientDetail = (selectedPatient) => {
		if(!selectedPatient.pid || selectedPatient.pid==="Not_linked"){
			alert("앱에서 등록이 필요한 환자입니다.");
			return;
		}
		navigate(`/dtx001/patient-manage/list/${selectedPatient.pid}`);
		sessionStorage.setItem('firstTrainingStart',tableBody.filter(e=>e.pid===selectedPatient.pid)[0].firstTrainingStart)
	}

	function convertPatientType(problem, change) {
		if(problem==="High" && change==="Ready") return "HR";
		else if(problem==="High" && change==="No") return "HN";
		else if(problem==="Low" && change==="Ready") return "LR";
		else return "LN";
	}

	// eslint-disable-next-line no-unused-vars
	function getAlertMessage() {
		if(Boolean(searchOption.patientTypeChange) + Boolean(searchOption.patientTypeProblem)===1){
			alert("환자 타입 - 문제성 음주와변화 준비를 모두 선택하세요.");
		}
	}
	async function getPatientListFromAPI() {
		if(Boolean(searchOption.patientTypeChange) + Boolean(searchOption.patientTypeProblem)===1){
			return;
		}
		let request = {};
		try{
			request = {
				...(searchOption.search && { text: searchOption.search }),
				...(searchOption.patientTypeProblem && searchOption.patientTypeChange && { "patient-type" : convertPatientType(searchOption.patientTypeProblem, searchOption.patientTypeChange)}),
				...(searchOption.patientGroup && { "patient-group" : pageInfo.dataMatchKorToEng.searchOption.patientGroup[searchOption.patientGroup]}),
				...(searchOption.progress && searchOption.progress!=="전체" && { training: pageInfo.dataMatchKorToEng.searchOption.training[searchOption.progress] }),
				...(selectedOrderOption && { order: selectedOrderOption }),
				...(selectedPage && { page: selectedPage })
			}
			const res = await getPatientFromAlcohol(request);
			
			if(parseInt(res.status/200,10)===1){
				if(res.data.length>0){
					const newTableBody = res.data.map(e=>({
						pid: e.pid,
						firstTrainingStart: e.firstTrainingStart || "",
						번호: e[pageInfo.dataMatchKorToEng.key.번호] || "",
						이름: e[pageInfo.dataMatchKorToEng.key.이름] || "",
						'의료진 코드': e[pageInfo.dataMatchKorToEng.key['의료진 코드']] || "",
						전화번호: e[pageInfo.dataMatchKorToEng.key.전화번호] || "",
						생년월일: e[pageInfo.dataMatchKorToEng.key.생년월일] || "",
						성별: e[pageInfo.dataMatchKorToEng.key.성별] || "",
						나이: e[pageInfo.dataMatchKorToEng.key.나이] || "",
						환자군: pageInfo.dataMatchEngToKor.patientGroup[e[pageInfo.dataMatchKorToEng.key.환자군]] || "",
						'문제성 음주': e[pageInfo.dataMatchKorToEng.key['문제성 음주']] || "",
						'변화 준비': e[pageInfo.dataMatchKorToEng.key['변화 준비']] || "",
						교육: pageInfo.dataMatchEngToKor.training[e.training] || ""
					}))
					setTableBody(newTableBody);
					setTotalDataCnt(res.data[0].totalCnt);
				}else{
					setTableBody([]);
					setTotalDataCnt(0);
				}
			}
		}catch(err){
			console.log(err);
			
		}
	}

	// 신규 환자 추가 modal
	const [showRegisterPatientModal, setShowRegisterPatientModal] = useState(false);
	const [newPatientDisplayName, setNewPatientDisplayName] = useState('');
	const [newPatientBirthYear, setNewPatientBirthYear] = useState(new Date().getFullYear());
	const [newPatientBirthMonth, setNewPatientBirthMonth] = useState(new Date().getMonth() + 1);
	const [newPatientBirthDay, setNewPatientBirthDay] = useState(new Date().getDate());
	const [newPatientSex, setNewPatientSex] = useState("");
	const [newPatientPhone1, setNewPatientPhone1] = useState('');
	const [newPatientPhone2, setNewPatientPhone2] = useState('');
	const [newPatientPhone3, setNewPatientPhone3] = useState('');	
	const [newPatientGroup, setNewPatientGroup] = useState("");
	const [newPatientDoctorCode, setNewPatientDoctorCode] = useState('');

	// 신규 환자 추가 실패 (이미 존재하는 환자) modal
	const [showExistPatientModal, setShowExistPatientModal] = useState(false);

	// 환자 삭제 modal
	const [showDeletePatientModal, setShowDeletePatientModal] = useState(false);

	const closeRegisterPatientModal = () => {
		setShowRegisterPatientModal(false);
		setNewPatientDisplayName('');
		setNewPatientPhone1('');
		setNewPatientPhone2('');
		setNewPatientPhone3('');
		setNewPatientSex('');
		setNewPatientGroup('');
		setNewPatientBirthYear(new Date().getFullYear());
		setNewPatientBirthMonth(new Date().getMonth() + 1);
		setNewPatientBirthDay(new Date().getDate());
		setNewPatientDoctorCode('');
	}

	// 신규 환자 등록하는 function
	async function registerNewPatient() {
		if(!newPatientGroup || !newPatientDisplayName.trim() || !newPatientSex || !newPatientPhone1.trim() || !newPatientPhone2.trim() || !newPatientPhone3.trim() || !newPatientDoctorCode.trim()){
			alert("환자 정보를 모두 입력해주세요.");
			return;
		}
		try{
			if (
				newPatientDisplayName.trim() !== '' &&
				newPatientSex &&
				newPatientPhone1.trim() !== '' &&
				newPatientPhone2.trim() !== '' &&
				newPatientPhone3.trim() !== '' &&
				newPatientGroup &&
				newPatientDoctorCode.toString().trim() !== ''
			) {
				const request = {
					name: newPatientDisplayName,
					sex: newPatientSex,
					birth:
						newPatientBirthYear.toString() +
						newPatientBirthMonth.toString().padStart(2, 0) +
						newPatientBirthDay.toString().padStart(2, 0),
					phoneNumber: newPatientPhone1 + newPatientPhone2 + newPatientPhone3,
					patientGroup: newPatientGroup,
					psctCode: newPatientDoctorCode,
				};
	
				const res = await postPatientToAlcohol(request);
				if(parseInt(res.status/200,10)===1){
					if(res.data==="Duplicate"){
						setShowExistPatientModal(true);
						return;
					}else if(res.data==="FAIL"){
						alert("신규 환자 추가에 실패하였습니다.");
						return;
					}
					closeRegisterPatientModal();
					getPatientListFromAPI();
				}else{
					alert("신규 환자 추가에 실패하였습니다.");
				}
			} else {
				alert('환자 정보를 모두 입력해주세요.');
			}
		}catch(err){
			console.error(err);
			alert("신규 환자 추가에 실패하였습니다.");
		}		
	}

	// 처방 코드 생성하는 function
	async function CreatePsctCode() {
		try {
			const res = await getPsctCodeFromAlcohol();
			if(parseInt(res.status/200,10)===1){
				setNewPatientDoctorCode(String(res.data));
			}else{				
				alert("의료진 코드 생성에 실패하였습니다.");
			}
		}catch(err){
			console.error(err);
			alert("의료진 코드 생성에 실패하였습니다.");
		}
	}

	// 신규 환자 modal 생년월일 select option
	const birthYear = () => {
		const yearItems = [];
		for (let year = 1900; year <= new Date().getFullYear(); year++) {
			yearItems.push(
				<option key={year} value={year}>
					{year}
				</option>,
			);
		}
		return yearItems;
	};
	const birthMonth = () => {
		const monthItems = [];
		const currentYear = new Date().getFullYear();
		const currentMonth = new Date().getMonth() + 1; // getMonth()는 0부터 시작
		// 선택된 생년(newPatientBirthYear)이 현재 연도라면, 최대 월을 현재 월로 제한
		const maxMonth = parseInt(newPatientBirthYear, 10) === currentYear ? currentMonth : 12;
		
		for (let month = 1; month <= maxMonth; month++) {
		  monthItems.push(
			<option key={month} value={month}>
			  {month}
			</option>,
		  );
		}
		return monthItems;
	  };
	  const birthDay = () => {
		const dayItems = [];
		const currentDate = new Date();
		const currentYear = currentDate.getFullYear();
		const currentMonth = currentDate.getMonth() + 1; // getMonth()는 0부터 시작
		const currentDay = currentDate.getDate();
	  
		// 선택된 연도와 월에 따른 해당 월의 최대 일수
		const maxDayInMonth = new Date(parseInt(newPatientBirthYear, 10), parseInt(newPatientBirthMonth, 10), 0).getDate();
		
		// 만약 선택된 연도와 월이 현재 연도와 월이라면, 최대 일수를 현재 일로 제한합니다.
		const allowedDay = (parseInt(newPatientBirthYear, 10) === currentYear &&
							  parseInt(newPatientBirthMonth, 10) === currentMonth)
							  ? currentDay
							  : maxDayInMonth;
	  
		for (let day = 1; day <= allowedDay; day++) {
		  dayItems.push(
			<option key={day} value={day}>
			  {day}
			</option>
		  );
		}
		return dayItems;
	  };
	  

	const registerPatientModalBody = (
		<div className="modalbody">
			<div className="formModalItem">
				<div className="formModalItem__label_large">환자군</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="실험군"
							value="exp"
							name="patient-group"
							checked={newPatientGroup === 'exp'}
							onChange={e => setNewPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="실험군" className="formModalItem__input__radioLabel">
							실험군
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="대조군"
							value="comp"
							name="patient-group"
							checked={newPatientGroup === 'comp'}
							onChange={e => setNewPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="대조군" className="formModalItem__input__radioLabel">
						대조군
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="테스트"
							value="tester"
							name="patient-type"
							checked={newPatientGroup === 'tester'}
							onChange={e => setNewPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="테스트" className="formModalItem__input__radioLabel">
							테스트
						</label>
					</div>
				</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="일반"
							value="common"
							name="patient-type"
							checked={newPatientGroup === 'common'}
							onChange={e => setNewPatientGroup(e.target.value)}
						/>{' '}
						<label htmlFor="일반" className="formModalItem__input__radioLabel">
							일반
						</label>
					</div>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">이름</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__plainText"
						placeholder="이름"
						value={newPatientDisplayName}
						onChange={e => {
							const raw = e.target.value;
                            const filtered = raw.replace(/[^ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');
							setNewPatientDisplayName(filtered);
						}}
						maxLength={30}
					/>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">성별</div>
				<div className="formModalItem__input">
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="male"
							value="M"
							name="gender"
							checked={newPatientSex === 'M'}
							onChange={e => setNewPatientSex(e.target.value)}
						/>{' '}
						<label htmlFor="male" className="formModalItem__input__radioLabel">
							남자
						</label>
					</div>
					<div className="formModalItem__input__radio formModalItem__input__radio_limit_width120">
						<input
							type="radio"
							id="female"
							value="F"
							name="gender"
							checked={newPatientSex === 'F'}
							onChange={e => setNewPatientSex(e.target.value)}
						/>{' '}
						<label htmlFor="female" className="formModalItem__input__radioLabel">
							여자
						</label>
					</div>
				</div>
			</div>
			<div className="formModalItem">
				<div className="formModalItem__label">휴대폰 번호</div>
				<div className="formModalItem__input">
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={newPatientPhone1}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							if (filtered.length > 3) {
								setNewPatientPhone1(filtered.slice(0, 3));
							} else {
								setNewPatientPhone1(filtered);
							}
						}}
						size={3}
						maxLength={3}
						placeholder="010"
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={newPatientPhone2}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							if (filtered.length > 4) {
								setNewPatientPhone2(filtered.slice(0, 4));
							} else {
								setNewPatientPhone2(filtered);
							}
						}}
						size={4}
						maxLength={4}
						placeholder="1234"
					/>
					<span className="phoneDivider">-</span>
					<input
						type="text"
						className="formModalItem__input__phoneNumber"
						value={newPatientPhone3}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							if (filtered.length > 4) {
								setNewPatientPhone3(filtered.slice(0, 4));
							} else {
								setNewPatientPhone3(filtered);
							}
						}}
						size={4}
						maxLength={4}
						placeholder="5678"
					/>
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">생년월일</div>
				<div className="formModalItem__input">
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthYear(e.target.selectedOptions[0].value)}
						value={newPatientBirthYear}
					>
						{birthYear()}
					</select>
					<span className="birthText">년</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthMonth(e.target.selectedOptions[0].value)}
						value={newPatientBirthMonth}
					>
						{birthMonth()}
					</select>
					<span className="birthText">월</span>
					<select
						className="formModalItem__input__birth"
						onChange={e => setNewPatientBirthDay(e.target.selectedOptions[0].value)}
						value={newPatientBirthDay}
					>
						{birthDay()}
					</select>
					<span className="birthText">일</span>
				</div>
			</div>			
			<div className="formModalItem">
				<div className="formModalItem__label">의료진 코드</div>
				<div className="formModalItem__input">
					<input
						type="text"
						readOnly
						className="formModalItem__input__plainTextWithButton"
						placeholder="의료진 코드"
						value={newPatientDoctorCode}
						onChange={e => {
							const raw = e.target.value;
							const filtered = raw.replace(/[^0-9]/g, '');
							setNewPatientDoctorCode(filtered);
						}}
						maxLength={10}
					/>
					<button
						className="submitButton__rounded"
						onClick={() => CreatePsctCode()}
						disabled={!(newPatientDisplayName && newPatientPhone1 && newPatientPhone2 && newPatientPhone3 && newPatientSex && newPatientGroup)}
					>
						생성
					</button>
				</div>
			</div>
		</div>
	);

	const registerPatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={() => registerNewPatient()}
				disabled={newPatientDoctorCode===""}
			>
				저장
			</button>
			<button className="cancelButton__rounded" onClick={() => closeRegisterPatientModal()}>
				취소
			</button>
		</div>
	);

	// 신규 환자 추가 실패 modal
	const closeExistPatientModal = () => {
		setShowExistPatientModal(false);
	}

	const existPatientModalBody = <div className="modalbody">이미 등록된 환자입니다.</div>;

	const existPatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={() => closeExistPatientModal()}
				style={{ width: '100%' }}
			>
				확인
			</button>
		</div>
	);

	// 환자 삭제 modal
	const closeDeletePatientModal = () => {
		setShowDeletePatientModal(false);
	}
	
	async function deleteSelectedPatient() {
		try{
			const request = Object.values(selectedPatients).map(e=>Number(e.번호));
			const res = await deletePatientFromAlcohol(request);
			if(parseInt(res.status/200,10)===1 && res.data==="OK"){
				getPatientListFromAPI();
			}else{				
				alert("환자 삭제에 실패하였습니다.");
			}
		}catch(err){
			console.error(err);
			alert("환자 삭제에 실패하였습니다.");
		}finally{
			closeDeletePatientModal();
			setSelectedPatients([]);
			setTotalCheck(false);
		}		
	}

	const deletePatientModalBody = (
		<div className="modalbody">
			<div className="spanWrapContainer">
				<span>해당 환자를 삭제하시겠습니까?</span>
				<table className='AlcoholCommonTable'>
					<thead>
						<tr>
							{pageInfo.list.deleteTableHeader.map(headerItem=>(
								<th key={headerItem}>{headerItem}</th>
							))}
						</tr>
					</thead>
					<tbody>
						{Object.values(selectedPatients).map((patientInfo, idx) => (
							<tr key={idx}>
								{pageInfo.list.deleteTableHeader.map(headerItem=>(
									<td key={headerItem}>{patientInfo[headerItem]}</td>
								))}
							</tr>
						))}
					</tbody>
				</table>
			</div>
		</div>
	);

	const deletePatientModalFooter = (
		<div className="modalfooter">
			<button
				className="submitButton__rounded"
				onClick={() => deleteSelectedPatient()}
				style={{ width: '100% !important' }}
			>
				삭제
			</button>
			<button
				className="cancelButton__rounded"
				onClick={() => closeDeletePatientModal()}
				style={{ width: '100% !important' }}
			>
				취소
			</button>
		</div>
	);

	// pagination
	const getNewTableDataByPagination = (page) => {
		setSelectedPage(page);
		setSelectedPatients([]);
		setTotalCheck(false);
	}

	// 검색 조건 초기화 
	const resetSearchOption = () => {
		setInputSearchOption({
			search: "",
			patientTypeProblem: "",
			patientTypeChange: "",
			patientGroup: "",
			progress: ""
		})
	}

	const applySearchOption = () => {
		setSearchOption(inputSearchOption);		
	}

	useEffect(() => {
		if(Boolean(searchOption.patientTypeChange) + Boolean(searchOption.patientTypeProblem)===1){
			alert("환자 타입 - 문제성 음주와변화 준비를 모두 선택하세요.");
		}
	}, [searchOption]);

	useEffect(() => {
		async function getPatientList() {
			await getPatientListFromAPI();
		}
		getPatientList();
		getNewTableDataByPagination(1);
	}, [selectedOrderOption]);

	useEffect(()=>{
		getPatientListFromAPI();
	},[selectedPage])

	useEffect(()=>{
		getPatientListFromAPI();
		getNewTableDataByPagination(1);
	},[searchOption])


	return (
		<div>
			<SearchTablePageLayout
				type="patient"
				pageInfo={pageInfo}

				tableBody={tableBody}
				totalCnt={totalDataCnt}

				tablePageCnt={Math.ceil(totalDataCnt/10) || 1}
				selectedPage={selectedPage}
				setSelectedPage={setSelectedPage}
				getNewTableDataByPagination={getNewTableDataByPagination}

				setShowRegisterModal={setShowRegisterPatientModal}
				setShowDeleteModal={setShowDeletePatientModal}
				
				checkedItems={selectedPatients}
				setCheckedItems={setSelectedPatients}
				totalCheck={totalCheck}
				setTotalCheck={setTotalCheck}

				searchOption={inputSearchOption}
				setSearchOption={setInputSearchOption}
				resetSearchOption={resetSearchOption}
				applySearchOption={applySearchOption}

				selectedOrderOption={selectedOrderOption}
				setSelectedOrderOption={setSelectedOrderOption}

				clickEvent={goToSelectedPatientDetail}
			/>
			{/* 신규 추가 modal */}
			<CommonModal
				header="신규 환자 추가"
				body={registerPatientModalBody}
				footer={registerPatientModalFooter}
				show={showRegisterPatientModal}
				setClose={closeRegisterPatientModal}
				size="lg"
			/>
			{/* 신규 추가 실패 (이미 존재하는 환자) modal */}
			<CommonModal
				header="신규 환자 등록"
				body={existPatientModalBody}
				footer={existPatientModalFooter}
				show={showExistPatientModal}
				setClose={closeExistPatientModal}
				size="sm"
			/>
			{/* 환자 삭제 modal */}
			<CommonModal
				header="환자 삭제"
				body={deletePatientModalBody}
				footer={deletePatientModalFooter}
				show={showDeletePatientModal}
				setClose={closeDeletePatientModal}
				size="lg"
			/>
		</div>
	);
}

export default AlcoholPatientManageListPage;
